import { ReservedItem } from '@grpc-clients/external/mercury/v1/entertainment/entertainment.pb';
import { createSelector } from '@ngrx/store';
import { getEntertainmentTicketDetailsSearchState } from '../reducers';

export const getTicketEventDetailsStates = createSelector(getEntertainmentTicketDetailsSearchState, (state) => state);

export const getTicketEventDetails = createSelector(getTicketEventDetailsStates, (state) => state.eventDetails);

export const getReserveTickets = createSelector(getTicketEventDetailsStates, (state) => state.reserveTickets);

export const isDetailsLoading = createSelector(getTicketEventDetailsStates, (state) => state.loading);

export const isDetailsLoaded = createSelector(getTicketEventDetailsStates, (state) => state.loaded);

export const getTicketEventPerformances = createSelector(
  getTicketEventDetailsStates,
  (state) => state.calendarDetails.performances
);

export const getCalenderLoaded = createSelector(
  getTicketEventDetailsStates,
  (state) => state.calendarDetails.isCalendarLoaded
);

export const getCalenderLoading = createSelector(
  getTicketEventDetailsStates,
  (state) => state.calendarDetails.isCalendarLoading
);

export const getTicketEventPerformancesAvailability = createSelector(
  getTicketEventDetailsStates,
  (state) => state.performancesAvailability.performancesAvailability
);

export const getAvailabilityLoaded = createSelector(
  getTicketEventDetailsStates,
  (state) => state.performancesAvailability.isPerformanceAvailabilityLoaded
);

export const getAvailabilityLoading = createSelector(
  getTicketEventDetailsStates,
  (state) => state.performancesAvailability.isPerformanceAvailabilityLoading
);

export const getTicketBookingInfo = createSelector(getTicketEventDetailsStates, (state) => {
  return {
    total_amount: state.reserveTickets?.data?.totalPrice?.value,
    event_name: state.eventDetails?.eventName,
    venue_name: state.eventDetails?.venue?.venueName,
    city: state.eventDetails?.venue?.venueLocation,
    performanceId: state.reserveTickets?.performanceId,
    selectedSeats: getDynamicSelectedSeats(state.reserveTickets?.data?.reservedItems),
  };
});

export const getIsDynamicSeatMapDirty = createSelector(
  getTicketEventDetailsStates,
  (state) => state.dynamicSeatMapDirty
);

const getDynamicSelectedSeats = (items: ReservedItem[]) => {
  const seats = items?.reduce(
    (res: string[], item: ReservedItem) => [
      ...res,
      ...item.seats.reduce((acc, seat) => [...acc, getSeatName(seat)], []),
    ],
    []
  );
  return seats?.filter((seat) => !!seat);
};

const getSeatName = (seat) => {
  if (!seat.displayName) {
    return '';
  }
  const seatCategory = seat.seatText?.value ? ` (${seat.seatText.value})` : '';
  return `${seat.displayName.value}${seatCategory}`;
};
